module.exports = __webpack_public_path__ + "static/media/marcas-tarjetas.6031ac1e.png";